import { getDomainName, objectToQueryString } from '~/utils/urlUtils';

// Social Auth Buttons
import config from '~/config/config.json';
import GoogleLoginBtn from '~/shared/loginmodule/components/SocialAuthBtns/GoogleLoginBtn';
import FacebookLoginBtn from '~/shared/loginmodule/components/SocialAuthBtns/FacebookLoginBtn';
import LinkedInLoginBtn from '~/shared/loginmodule/components/SocialAuthBtns/LinkedInLoginBtn';
import WeChatLogInBtn from '~/shared/loginmodule/components/SocialAuthBtns/WeChatLoginBtn';

// SocialAuth communication clients
import GoogleFlow from './GoogleFlow';
import FacebookFlow from './FacebookFlow';
import LinkedInFlow from './LinkedInFlow';

export const providerFlowByName = providerName => {
    switch (providerName) {
        case 'Google':
            return GoogleFlow;
        case 'Facebook':
            return FacebookFlow;
        case 'LinkedIn':
            return LinkedInFlow;
        default:
            return null;
    }
};

/**
 * The OAuth state should be a encoded query-string ("key1=value1&key2=value2")
 */
export const buildOAuthState = (redirectPath, redirectQuery, customState = {}) => {
    const state = Object.entries({
        ...customState,
        origin:
            getDomainName() +
            (redirectPath ? encodeURIComponent(redirectPath) : '/redirect') +
            (redirectQuery && !redirectPath ? objectToQueryString(redirectQuery) : ''),
    })
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');

    return btoa(state);
};

// All supported social auth buttons
const SOCIAL_AUTHS = {
    Google: GoogleLoginBtn,
    Facebook: FacebookLoginBtn,
    LinkedIn: LinkedInLoginBtn,
    WeChat: WeChatLogInBtn,
};

const initializeSocialAuthButtons = () => {
    // Add the socialAuth-providers that is not in the config at the bottom of the list
    const socialAuthList = config.socialAuths || [];
    for (let providerName in SOCIAL_AUTHS) {
        const index = socialAuthList.findIndex(e => e === providerName);
        if (index === -1) {
            socialAuthList.push(providerName);
        }
    }

    // Create a list with the name and button-component for all socialAuth-providers
    const socialAuthComponents = [];
    for (let providerName of socialAuthList) {
        const component = SOCIAL_AUTHS[providerName];
        if (!component) {
            continue;
        }
        socialAuthComponents.push({ name: providerName, comp: component });
    }
    return socialAuthComponents;
};

export const socialAuthButtons = initializeSocialAuthButtons();
